import React from 'react'

import Tag from '../../../packages/kiti/components/presentation/Tag'
import TriggerCallsCountLoader, { useTriggerCallsCount } from './TriggerCallsCountLoader'

const TagTriggerCalls = ({ label, color }) => {
  const triggerCallsCount = useTriggerCallsCount()

  if (triggerCallsCount === 0 || triggerCallsCount == null) return null

  return <Tag label={`${label} (${triggerCallsCount})`} color={color} size="xsmall" />
}

const Wrapper = ({ label, color, ...prop }) => {
  return (
    <TriggerCallsCountLoader {...prop}>
      <TagTriggerCalls label={label} color={color} />
    </TriggerCallsCountLoader>
  )
}

export default Wrapper
